import React from 'react';

import { useDataAttributes } from '@lumapps/data-attributes';
import { mdiReplyOutline } from '@lumapps/lumx/icons';
import type { ButtonProps } from '@lumapps/lumx/react';
import { ReactionButton } from '@lumapps/reactions-core/components/ReactionButton';
import { REACTIONS_SCOPE } from '@lumapps/reactions-core/constants';
import { GLOBAL, useTranslate } from '@lumapps/translations';

export interface ReplyButtonProps extends ButtonProps {
    onClick?: () => void;
}

export const ReplyButton: React.FC<ReplyButtonProps> = ({ onClick, ...buttonProps }) => {
    const { translateKey } = useTranslate();
    const { get } = useDataAttributes(REACTIONS_SCOPE);
    return (
        <ReactionButton
            onClick={onClick}
            leftIcon={mdiReplyOutline}
            size="s"
            {...buttonProps}
            {...get({ element: 'button', action: 'reply-to-comment' })}
        >
            {translateKey(GLOBAL.REPLY)}
        </ReactionButton>
    );
};
